import type { FunctionComponent } from "react";

import { StyledVideoRecorder, VideoTitle, VideoTitleContainer } from "./styles";

export type Props = {
  isHeroVideo?: boolean;
  title?: string;
};

export const SCMPYouTubeVideoFooter: FunctionComponent<Props> = ({ isHeroVideo, title }) => {
  if (!title) return null;
  return (
    <VideoTitleContainer $isHeroVideo={isHeroVideo}>
      <StyledVideoRecorder />
      <VideoTitle>{title}</VideoTitle>
    </VideoTitleContainer>
  );
};

SCMPYouTubeVideoFooter.displayName = "SCMPYouTubeVideoFooter";
